export const autoplay = (cb = () => {}, delay, startCb = () => {}) => {
  const now = new Date();
  const nextMinute = new Date(now);
  nextMinute.setMinutes(now.getMinutes() + 1, 0, 0);

  const timeToNextMinute = nextMinute - now;

  setTimeout(() => {
    startCb();
    setInterval(() => {
      startCb();
    }, 10 * 1000);

    setTimeout(() => {
      cb();
      setInterval(() => {
        cb();
      }, 10 * 1000);
    }, delay);
  }, timeToNextMinute);
};

export const syncplay = (cb, unit = 5) => {
  const now = new Date();
  const nextMinute = new Date(now);
  nextMinute.setSeconds((Math.floor(now.getSeconds() / unit) + 1) * unit, 0);

  const timeToNextMinute = nextMinute - now;

  setTimeout(() => {
    cb();
  }, timeToNextMinute);
};

export const duplicate = (item, count) => {
  return Array.from(Array(count), () => item);
};

export const getTimeOfTheDay = () => {
  const timeStrings = ['day', 'noon', 'night'];

  const currentHour = new Date().getHours();

  let str;

  if (currentHour >= 5 && currentHour < 12) {
    // 5 ~ 12
    str = timeStrings[0];
  } else if (currentHour >= 12 && currentHour < 18) {
    // 12 ~ 18
    str = timeStrings[1];
  } else {
    // 18 ~ 5
    str = timeStrings[2];
  }

  return [str, timeStrings.filter((s) => s !== str)];
};
